import { singletonGetter } from "../../singletons/getter";

import { ActionName } from "./types";

export class PageLoadTracker {
  static get = singletonGetter(PageLoadTracker);

  private pagesLoaded = new Map<ActionName, boolean>();

  wasPageLoaded = (pageName: ActionName): boolean =>
    this.pagesLoaded.get(pageName) ?? false;

  setPageLoaded = (pageName: ActionName): void => {
    this.pagesLoaded.set(pageName, true);
  };
}
